module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7k8ht"))).then(() => parcelRequire('geNss'));